import { useEffect, useState } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { firestore } from "../shared/FirebaseConfig";
import { CHECKLISTS } from "../shared/checklistData";
import { useUser } from "../shared/UserContext";

// Live list of the teacher's own checklists for one class. Owner-scoped + classId
// so the query is the teacher's own data (rules-safe, no cross-school read).
// Sorted client-side by createdAt to avoid needing a composite index.
export default function useChecklists(classId) {
  const { uid } = useUser();
  const [checklists, setChecklists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid || !classId) {
      setChecklists([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    return onSnapshot(
      query(
        collection(firestore, CHECKLISTS),
        where("ownerUid", "==", uid),
        where("classId", "==", classId),
      ),
      snap => {
        const rows = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        rows.sort((a, b) => {
          const am = a.createdAt?.toMillis?.() ?? 0;
          const bm = b.createdAt?.toMillis?.() ?? 0;
          return am - bm;
        });
        setChecklists(rows);
        setLoading(false);
      },
      err => { console.error("[useChecklists]", err); setLoading(false); },
    );
  }, [uid, classId]);

  return { checklists, loading };
}
